var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BContainer',{style:(_vm.container_style),attrs:{"fluid":"","id":"container"}},[(!_vm.noQAWarning)?_c('ocom-qa-warning'):_vm._e(),_c('transition',{attrs:{"enter-active-class":"animated fadeIn","name":"router-anim"}},[_c('router-view',{key:_vm.$route.path})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }